module.exports = __webpack_public_path__ + "img/fawrypay-light.a1cc9a4f.svg";